import { render } from "./Choose.vue?vue&type=template&id=08b448b2&scoped=true"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"

import "./Choose.vue?vue&type=style&index=0&id=08b448b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b448b2"]])

export default __exports__